import FAQ from 'components/common/AccordionItem';
import Term from 'components/common/TermToggle';
import Explanation from 'components/custom/TermExplanation';
import * as React from 'react';
export default {
  FAQ,
  Term,
  Explanation,
  React
};